import { useCallback, useEffect, useState } from "react";
import type { BroadcastMessage } from "@/components/BroadcastBanner";

export function useBroadcasts(initialBroadcasts: BroadcastMessage[]) {
  const [broadcasts, setBroadcasts] = useState(initialBroadcasts);
  const [activeBroadcast, setActiveBroadcast] =
    useState<BroadcastMessage | null>(null);
  const [dismissedBroadcasts, setDismissedBroadcasts] = useState<string[]>([]);

  useEffect(() => {
    setBroadcasts(initialBroadcasts);
  }, [initialBroadcasts]);

  useEffect(() => {
    const checkBroadcasts = () => {
      const now = new Date();
      const active = broadcasts.find((b) => {
        const start = new Date(b.startTime);
        const end = new Date(b.endTime);
        return (
          now >= start && now <= end && !dismissedBroadcasts.includes(b.id)
        );
      });
      setActiveBroadcast(active || null);
    };

    checkBroadcasts();
    const interval = setInterval(checkBroadcasts, 60000);

    return () => clearInterval(interval);
  }, [broadcasts, dismissedBroadcasts]);

  const scheduleBroadcast = useCallback((broadcast: BroadcastMessage) => {
    setBroadcasts((prev) => [...prev, broadcast]);
  }, []);

  const dismissBroadcast = useCallback((id: string) => {
    setDismissedBroadcasts((prev) => [...prev, id]);
  }, []);

  return {
    broadcasts,
    activeBroadcast,
    scheduleBroadcast,
    dismissBroadcast,
  };
}
